"use client";

import PricingCtaSection from "@/components/ui/pricing-cta-section";

export default function MobilePricingCta() {
  return <PricingCtaSection id="cta-heading" heading="Ready to run on real mobile IPs?" />;
}
